import inboxSocialIntegration from '../modules/inbox-social-integration';

const initialize = () => {
    const inboxSocial = new inboxSocialIntegration("btn-social-provider");
    inboxSocial.registerRedirectQueryDataHandler();
    inboxSocial.registerLoginClickHandler();
};

export default initialize;
